module.exports = __webpack_public_path__ + "static/ny3-comp.b4341db3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ny3-comp.jpg
// module id = 447
// module chunks = 35783957827783